export const ModulesItems = [
    {
        frontTitle: 'Cash & Liquidity Management',
        frontImage: 'assets/img/modules/Cash & Liquidity Mangaement.png',
        backTilte: 'neque vitae tempus quam pellentesque nec nam aliquam sem et',
        routerLink: '/'
    },
    {
        frontTitle: 'Checks Management',
        frontImage: 'assets/img/modules/Checks Management.png',
        backTilte: 'It facilitates capturing of check items remotely from corporate locations',
        routerLink: '/modules/checksManagement'
    },
    {
        frontTitle: 'Payments',
        frontImage: 'assets/img/modules/payments.png',
        backTilte: 'iaculis nunc sed augue lacus viverra vitae congue eu consequat',
        routerLink: '/'
    },
    {
        frontTitle: 'Trase Finance',
        frontImage: 'assets/img/modules/Trase Finance.png',
        backTilte: 'urna et pharetra pharetra massa massa ultricies mi quis hendrerit',
        routerLink: '/'
    },
    {
        frontTitle: 'Report',
        frontImage: 'assets/img/modules/Trase Finance.png',
        backTilte: 'urna et pharetra pharetra massa massa ultricies mi quis hendrerit',
        routerLink: '/'
    },


];
